import { useState, useCallback, useEffect } from 'react';

export const useText = (initialText) => {
  const [text, setText] = useState(initialText);

  const textChange = useCallback((e) => {
    const { name, value } = e.target;
    setText((text) => ({ ...text, [name]: value }));
  }, []);

  useEffect(() => {
    setText(initialText);
  }, [initialText]);

  return [
    text,
    setText,
    textChange,
    (field) => ({
      name: field,
      multiline: true,
      value: text[field],
      variant: 'outlined',
      className: 'my-2',
      label: field.replace('_hy', '').replace('_en', '').replace('_', ' '),
      fullWidth: true,
      onChange: textChange
    })
  ];
};
